<template>
    <div id="content-wrapper" class="container-fluid app-position">
        <div class="container-fluid">
            <div class="grid grid-bleed">
                <div class="col-md-2">
                </div>

                <div class="col-md-8">
                    <post :post="post" v-if="analyticsMode === false"></post>
                    <post-analytics ref="analytics" :post="post" v-if="group.can.edit && analyticsMode === true"></post-analytics>
                </div>

                <div class="col-md-2 justify-end">
                    <share-button :post="post" v-if="post.can.edit"></share-button>

                    <a class="btn btn-create btn-small" :class="{ btndropdown__open: dropdownOpen, btndropdown: true }" href="#" role="button" v-on:click.stop.prevent="toggleDropdown" v-if="post.can.edit || group.can.createPosts">
                        <i class="icon ion-md-more"></i>

                        <div class="btndropdown-menu">
                            <div class="btndropdown__group">
                                <ul>
                                    <li>
                                        <router-link :to="{ name: 'edit-post', params: { group: this.$route.params.group, post: this.$route.params.post }}" v-if="post.can.edit">
                                            Edit post
                                        </router-link>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" v-on:click.stop.prevent="openModal('copy-post')" v-if="group.can.createPosts">
                                            Duplicate post
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" v-on:click.stop.prevent="toggleAnalytics" v-if="post.can.edit">
                                            <span v-if="analyticsMode === false">Analytics</span>
                                            <span v-if="analyticsMode === true">Close Analytics</span>
                                        </a>
                                    </li>
                                    <li>
                                    </li>
                                </ul>
                            </div>
                            <div class="btndropdown__group">
                                <ul>
                                    <li>
                                        <a class="dropdown-item link-danger" v-on:click.stop.prevent="openModal('delete-post')" v-if="post.can.edit">
                                            Delete post
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </a>

                    <div class="modal micromodal-slide" id="copy-post" aria-hidden="true">
                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                                <div class="modal__content">
                                    <h3>Copy post "{{ post.title }}"</h3>
                                    <p>Are you sure you wish to copy "{{ post.title }}"?</p>
                                </div>
                                <footer class="modal__footer">
                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                    <button class="btn btn-success" v-on:click.stop.prevent="copyPost()">Copy</button>
                                </footer>
                            </div>
                        </div>
                    </div>

                    <div class="modal micromodal-slide" id="delete-post" aria-hidden="true">
                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                                <div class="modal__content" id="modal-new-category-content">
                                    <h3>Delete post "{{ post.title }}"</h3>
                                    <p>Are you sure you wish to delete "{{ post.title }}"?</p>
                                </div>
                                <footer class="modal__footer">
                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                    <button class="btn btn-danger" v-on:click.stop.prevent="deletePost(post.id)">Delete</button>
                                </footer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';
    export default {
        props: ['post', 'group'],
        data(){
            return {
                analyticsMode: false,
                dropdownOpen: false
            }
        },
        created() {

        },
        mounted(){
            MicroModal.init();
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            deletePost() {
                axios.delete('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post).then((response) => {
                    MicroModal.close('delete-post');
                    this.$router.push({ name: 'view-group', params: { group: this.$route.params.group } });
                }, (response) => {
                    this.error = response;
                });
            },
            toggleDropdown() {
                this.dropdownOpen = (this.dropdownOpen) ? false : true;
            },
            toggleAnalytics(){
                this.analyticsMode = this.analyticsMode ? false : true;
            },
            copyPost() {
                axios.post('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post + "/copy").then((response) => {
                    MicroModal.close('copy-post');
                    const post = response.data;

                    this.$router.push({ name: 'edit-post', params: { group: post.group.slug, post: post.slug }});
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>

<style lang="scss">
    .reactions-form{
        margin: 40px 0 20px 0;

        .btn{
            min-width: 4rem;
            font-size: 18px;
            margin-right: 5px;

            span{
                font-size: 12px;
            }
        }
    }
</style>
